export interface VarianceService {
  costReimbursements: CostReimbursementService[];
}

export interface CostReimbursementService {
  createdAt: string;
  patientName: string;
  varianceReason: string;
  varianceAmount: string;
  cardCommission: string;
  totalAmount: string;
  id: number;
  orderId: string;
  orderExternalId: string;
  costReimbursementId: number;
}

export interface VarianceSummaryService {
  costReimbursementSummary: {
    reimbursementSumWon: string;
    reimbursementSum: number;
    count: number;
  };
}

export const CostReimbursementReasonMap = {
  DIAGNOSIS_COST: '진료비',
  CANNOT_DELIVERY: '배달 불가',
  REFUSAL_OF_DISPENSING: '조제 거부',
  SEPARATE_PAYMENT: '별도 결제',
  INCORRECT_PRESCRIPTION: '-',
  POST_SELF_DELIVERY: '택배 자체 발송',
  QUICK_SELF_DELIVERY: '퀵 자체 발송',
  EXTRA_DELIVERY: '추가 배송',
  MEDICINE_COST: '조제비',
  QUICK_CANCEL_FEE: '퀵 취소 수수료',
  ETC: '기타'
} as const;

export type CostReimbursementReasonMap =
  keyof typeof CostReimbursementReasonMap;
